export const faqsPl = [
  {
    q: "Czym różni się przejęcie projektu od samego audytu lub utrzymania?",
    a: "Przejęcie to operacyjna zmiana dostawcy: dostęp, odpowiedzialność za produkcję, komunikacja i dalszy rozwój. Audyt może być etapem wejścia, a utrzymanie ze SLA — modelem po handouverze. Tu punktem startu jest zwykle frustracja tempem lub jakością poprzedniego vendora.",
  },
  {
    q: "Jak bezpiecznie zmienić dostawcę oprogramowania?",
    a: "NDA, inwentaryzacja dostępów (repo, CI/CD, chmura, store, domeny), krótka ocena ryzyk, plan handoveru i dopiero potem przejęcie odpowiedzialności za release'y. Unikamy „od dziś robimy wszystko”, zanim wiadomo, co stoi na produkcji.",
  },
  {
    q: "Czy musicie mieć pełny dostęp od poprzedniego software house?",
    a: "Im więcej dostępów, tym sprawniej. Da się startować przy częściowym handouverze, ale wtedy najpierw odzyskujemy kontrolę nad buildami, sekretami i środowiskami. Braki dokumentujemy jako ryzyka i koszt wejścia.",
  },
  {
    q: "Ile trwa przejęcie projektu IT?",
    a: "Prosty handouver (jedno repo, działający CI) to często 1–3 tygodnie do przejęcia dyżuru. Przy wielu systemach, braku CI albo sporze z poprzednim wykonawcą — dłużej. Po rozmowie podajemy realistyczny plan etapów.",
  },
  {
    q: "Czy zaczynacie od przepisania całego systemu?",
    a: "Nie. Domyślnie stabilizujemy produkcję i odzyskujemy tempo delivery, potem planujemy rozwój albo modernizację tam, gdzie naprawdę blokuje biznes. Rewrite tylko gdy audyt i ekonomia to uzasadniają.",
  },
  {
    q: "Co z wiedzą, która siedzi tylko u poprzedniego zespołu?",
    a: "Mapujemy „single points of knowledge”: kto zna deploy, płatności, integracje. Budujemy runbooki, dokumentację krytycznych ścieżek i listę pytań do domknięcia przed zakończeniem współpracy z poprzednim dostawcą — jeśli jeszcze jest możliwa.",
  },
  {
    q: "Czy przejęcie obejmuje też aplikacje mobilne i backend?",
    a: "Tak — appki, web, API, panele, infrastruktura. Zakres ustalamy pod to, co faktycznie chcecie przenieść: często start od produkcyjnego toru (deploy + krytyczne bugi), potem backlog funkcji.",
  },
  {
    q: "Jak wygląda rozliczenie na starcie współpracy?",
    a: "Zwykle: pakiet wejściowy (handover + stabilizacja), potem retainer SLA i/lub sprinty rozwojowe. Widełki dajemy po poznaniu stacku, liczby środowisk i historii problemów z poprzednim vendorrem.",
  },
] as const;
